import { render } from "./curriculum-vitae.vue?vue&type=template&id=c7b5de5e&scoped=true&ts=true"
import script from "./curriculum-vitae.vue?vue&type=script&lang=ts"
export * from "./curriculum-vitae.vue?vue&type=script&lang=ts"

import "./curriculum-vitae.vue?vue&type=style&index=0&id=c7b5de5e&scoped=true&lang=css"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b5de5e"]])

export default __exports__